import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SearchResultService {

  constructor(private http: HttpClient ) { }
  getSearchResultJson(url: string): Observable<any> {
    let requestOptions: Object = {responseType: "text"}
    return this.http.get<any>(url, requestOptions);
  }
}
